export const UPDATE_POI_LAUNCHED = 'map/UPDATE_POI_LAUNCHED';
export const UPDATE_POI_SUCCESS = 'map/UPDATE_POI_SUCCESS';
export const UPDATE_POI_FAILURE = 'map/UPDATE_POI_FAILURE';
export const SET_MAP_FULL_WIDTH = 'map/SET_MAP_FULL_WIDTH';
